// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._2t3DtyCkx{}._2t3DtyCkx{background-color:rgba(255,255,255,0.5);width:100%;margin:4px 0}._2XNylQTix{width:64px;height:64px;border-radius:100%}._1bVNtaWPx{height:34px;max-width:400px}._51Wu7Nlox{background-color:rgba(255,255,255,0.25);height:15px;max-width:200px}._5llw0gWIx{position:absolute;z-index:-1;left:0;top:0;right:0;bottom:0;background-repeat:no-repeat;background-position:top;background-size:100%;-webkit-filter:blur(40px);filter:blur(40px);transform:scale(1.2)}._3tPfAR4Dx{background:#787878}._1pLAPZRRx{display:flex;flex-direction:row;padding:32px 20px}@media (min-width: 768px){._1pLAPZRRx{max-width:640px;margin-left:auto;margin-right:auto}}._4xlgnHWox{margin-left:20px;flex:1}._1XOGOWXFx{font-weight:100}.raO5XLwDx{font-weight:400;margin-right:3px}._2b0z7xCgx{-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto;margin-top:-3px;margin-bottom:5px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"skeleton": "_2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"app-icon-skeleton": "_2XNylQTix _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"appIconSkeleton": "_2XNylQTix _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"heading-skeleton": "_1bVNtaWPx _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"headingSkeleton": "_1bVNtaWPx _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"paragraph-skeleton": "_51Wu7Nlox _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"paragraphSkeleton": "_51Wu7Nlox _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _2t3DtyCkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"background-app-icon": "_5llw0gWIx",
	"backgroundAppIcon": "_5llw0gWIx",
	"background-app-icon-skeleton": "_3tPfAR4Dx _5llw0gWIx",
	"backgroundAppIconSkeleton": "_3tPfAR4Dx _5llw0gWIx",
	"app-icon-and-text": "_1pLAPZRRx",
	"appIconAndText": "_1pLAPZRRx",
	"app-text": "_4xlgnHWox",
	"appText": "_4xlgnHWox",
	"app-text-info": "_1XOGOWXFx",
	"appTextInfo": "_1XOGOWXFx",
	"app-text-os": "raO5XLwDx",
	"appTextOs": "raO5XLwDx",
	"app-name": "_2b0z7xCgx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["wordwrap"] + "",
	"appName": "_2b0z7xCgx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["wordwrap"] + ""
};
module.exports = exports;
